module.exports = __webpack_public_path__ + "img/how_it_work_2.3cb920c0.png";